import type { IChipInputProps } from "@amphore-dev/amphore-lib";

import { TProjectsFilters } from "@/types";

/**
 * The client id the /projects filter uses for internal projects (no
 * client). No client has id 0, so one Select and one chip cover both.
 */
export const INTERNAL_CLIENT_ID = 0;

export const DEFAULT_PROJECTS_FILTERS: TProjectsFilters = {
	search: "",
	clientIds: [],
	display: "grouped",
	archived: false,
};

/** A project's ticket key, as stored (uppercased): a letter, then letters, digits or _. Same rule as the API. */
export const TICKET_PREFIX = /^[A-Z][A-Z0-9_]{0,19}$/;

export const MAX_TICKET_PREFIXES = 10;

/**
 * The ticket prefixes field, wherever a project is edited: typed in any
 * case, kept uppercase; a key that isn't one stays in the field to be
 * fixed instead of becoming a chip.
 */
export const TICKET_PREFIXES_CHIP_PROPS: Pick<
	IChipInputProps,
	"normalize" | "validate" | "rejectInvalid" | "maxCount"
> = {
	normalize: (value) => value.toUpperCase(),
	validate: (value) => TICKET_PREFIX.test(value),
	rejectInvalid: true,
	maxCount: MAX_TICKET_PREFIXES,
};
